import Alpine from "alpinejs";
if (import.meta.hot) {
  import.meta.hot.accept();
}

/* Import slider module js file */
import "./modules/slider.js";
import MD5 from "crypto-js/md5";
import { setAlignFullScrollBarWidth } from "./modules/utils.js";
import { Swiper as ThemeSwiper } from "swiper";
import {
  Autoplay as SwiperAutoplay,
  Navigation as SwiperNavigation,
  Scrollbar as SwiperScrollbar,
} from "swiper/modules";

/* GEKÅS OLD SCRIPT */

var itc_webp = {
  support: true,
  init: function () {
    var el = new Image();
    el.onload = el.onerror = function () {
      if (
        el.height == 2 &&
        navigator.userAgent.search("Edg/") == -1 &&
        !(
          navigator.userAgent.search("Safari") >= 0 &&
          navigator.userAgent.search("Chrome") < 0
        )
      )
        return true;
      itc_webp.support = false;
      itc_webp.search();
      window.addEventListener("load", itc_webp.search);
      window.addEventListener("resize", itc_webp.search);
    };
    el.src =
      "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
  },
  search: function () {
    if (itc_webp.support) return;
    document.querySelectorAll('img[src*=".webp"]').forEach(function (el) {
      el.src = el.src.replace(/.webp$/, "");
    });

    document
      .querySelectorAll('div.fp-slide-image[style*=".webp"]')
      .forEach(function (el) {
        el.setAttribute("style", el.getAttribute("style").replace(".webp", ""));
      });
  },
};
itc_webp.init();

window.itc_webp = itc_webp;

import "@/js/gekas/vendor/jquery-ui.p2h.min.js";
import "@/js/gekas/vendor/jquery-ui.multidatespicker.js";
import "@/js/gekas/vendor/jquery.magnific-popup.min.js";
import "@/js/gekas/vendor/jquery.validate.min.js";
import "@/js/gekas/vendor/formator.min.js";
import "@/js/gekas/vendor/jquery.cookie.js";
import "@/js/gekas/takeover/takeover.js";
// import '@/js/gekas/vendor/jquery-ui.autocomplete.min.js';

// import 'jquery-autocomplete';

/* ------------------------------------------------------------------------------------ */

Alpine.store("AllOpenSubMenus", {
  close() {
    document
      .getElementById("mobile-menu")
      .querySelectorAll("[x-data]")
      .forEach((el) => {
        el._x_dataStack.forEach((i) => {
          if (i.$data?.alwaysFoldedOut) {
            return;
          }

          if (i.$data.submenuOpen) {
            i.$data.submenuOpen = false;
          }
        });
      });
  },
});

Alpine.store("header", {
  toggleOverflowHidden() {
    const body = document.querySelector("body");
    body.style.overflow = body.style.overflow === "hidden" ? "auto" : "hidden";
  },
});

Alpine.start();

function handleBookingInfoPopup() {
  const template = `
        <h3>${gekas?.booking_info_popup?.heading}</h3>
        <p>${gekas?.booking_info_popup?.content}</p>
        <button title="Close (Esc)" type="button" class="mfp-close">×</button>
    `;

  $.magnificPopup.open({
    showCloseBtn: true,
    items: {
      src: '<div class="booking-info-popup-block">' + template + "</div>",
      type: "inline",
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const bookingInfoPopup = document.getElementById("booking-info-popup");
  if (bookingInfoPopup)
    bookingInfoPopup.addEventListener("click", handleBookingInfoPopup);

  // Define the class you want to detect when removed
  const classToDetect = "itc-takeover-visible";

  // Create a MutationObserver
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        const oldClassList = mutation.oldValue.split(" ");
        const currentClassList = mutation.target.classList;

        if (
          oldClassList.includes(classToDetect) &&
          !currentClassList.contains(classToDetect)
        ) {
          setAlignFullScrollBarWidth();
        }
      }
    });
  });

  if (typeof gekasAcf !== "undefined") {
    function get_cookie(name) {
      if (document.cookie.indexOf(name + "=") == -1) {
        return false;
      }
      var parts = ("; " + document.cookie).split("; " + name + "=");
      if (parts.length == 2) var value = parts.pop().split(";").shift();
      return value;
    }

    if (
      new Date().getTime() -
        (parseInt(get_cookie(MD5(gekasAcf.takeoverUrl).toString())) || 0) <
      86400 * 1000
    ) {
      setAlignFullScrollBarWidth();
      return;
    } else {
      var show = false;
      var state = ["show", "hide"];

      for (var k in state) {
        var s = state[k];
        var ws =
          gekasAcf.takeover.visibility[s].length > 0
            ? gekasAcf.takeover.visibility[s].split(",")
            : "";

        for (var i = 0; i < ws.length; i++) {
          if (ws[i].trim() == "/") {
            if (window.location.pathname == "/") {
              show = s == "show";
              break;
            }
          } else if (window.location.pathname == ws[i].trim()) {
            show = s == "show";
            break;
          }
        }
        if (!show) break;
      }

      if (!show) {
        setAlignFullScrollBarWidth();
        return;
      }
    }

    observer.observe(document.body, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
    });
  } else {
    setAlignFullScrollBarWidth();
  }

  const scrollableContainer = document.querySelector(".filter-header");

  let isDragging = false;
  let startX;
  let scrollLeft;

  if (!scrollableContainer) return;

  scrollableContainer.addEventListener("mousedown", (e) => {
    isDragging = true;
    scrollableContainer.classList.add("active");
    startX = e.pageX - scrollableContainer.offsetLeft;
    scrollLeft = scrollableContainer.scrollLeft;
    e.preventDefault(); // Prevent text selection while dragging
  });

  scrollableContainer.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const x = e.pageX - scrollableContainer.offsetLeft;
    const walk = (x - startX) * 2; // Adjust the multiplier for speed
    scrollableContainer.scrollLeft = scrollLeft - walk;
  });

  scrollableContainer.addEventListener("mouseup", () => {
    isDragging = false;
    scrollableContainer.classList.remove("active");
  });

  scrollableContainer.addEventListener("mouseleave", () => {
    isDragging = false;
    scrollableContainer.classList.remove("active");
  });
});

// Fix calendar issue when user use browser translate start
function fixChromeTranslation() {
  document
    .querySelectorAll(".ui-datepicker-calendar tr td font")
    .forEach((fontTag) => {
      let parent = fontTag.parentNode;
      parent.replaceChild(
        document.createTextNode(fontTag.textContent),
        fontTag,
      );
    });
}
const observer = new MutationObserver((mutations) => {
  mutations.forEach(() => fixChromeTranslation());
});
const datepickerObserverTarget = document.body;
observer.observe(datepickerObserverTarget, { childList: true, subtree: true });

// Create and run a script to adjust imbox position based on footer visibility.
// The React booking app mounts/removes #booking-footer-navigation after page
// load, and the ImBox widget injects its iframe asynchronously — so the footer
// is looked up fresh on every run and the observer watches the whole body.
function adjustImboxPosition() {
  // Get the footer element (may not exist yet, or may have been unmounted)
  const footer = document.querySelector("#booking-footer-navigation");

  // Get all frames that could be the imbox iframe
  const imboxFrames = document.querySelectorAll(
    "#imbox-container iframe, .imbox-frame iframe, #zoid-imbox-widget-uid_ed5f953d0c_mdk6mjg6nte .imbox-frame iframe",
  );

  if (imboxFrames.length === 0) {
    return;
  }

  // No footer in the DOM counts as hidden — imbox returns to the bottom
  const isFooterHidden =
    !footer ||
    window.getComputedStyle(footer).display === "none" ||
    footer.classList.contains("hidden");

  const targetBottom = isFooterHidden ? "0px" : "78px";

  // Update each potential iframe (only when the value changes, so the
  // body-wide MutationObserver below doesn't loop on our own writes)
  imboxFrames.forEach((iframe) => {
    if (iframe.style.getPropertyValue("bottom") !== targetBottom) {
      iframe.style.setProperty("bottom", targetBottom, "important");
    }
  });
}

// Run function immediately
adjustImboxPosition();

// Watch the whole body: catches the React booking bar mounting/unmounting,
// class/style toggles on it, and the ImBox iframe being injected late.
const observerBooking = new MutationObserver(adjustImboxPosition);
observerBooking.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["style", "class"],
});

// Also run on window resize
window.addEventListener("resize", adjustImboxPosition);

// Override carousel block pagination with scrollbar
document.addEventListener("DOMContentLoaded", () => {
  // Wait a bit for the plugin to initialize first
  setTimeout(() => {
    document
      .querySelectorAll(".circle-block .cb-carousel-block")
      .forEach((carousel) => {
        const swiperEl = carousel.querySelector(".swiper");
        if (!swiperEl || !swiperEl.swiper) return;

        // Destroy the existing Swiper instance
        swiperEl.swiper.destroy(true, true);

        // Get original settings
        const slidesPerView = parseInt(
          carousel.getAttribute("data-cb-slides-per-view"),
        );
        const slidesPerGroup = parseInt(
          carousel.getAttribute("data-cb-slides-per-group"),
        );
        const spaceBetween = parseInt(
          carousel.getAttribute("data-cb-space-between"),
        );
        const speed = parseInt(carousel.getAttribute("data-cb-speed"));
        const navigation =
          carousel.getAttribute("data-cb-navigation") === "true";
        const loop = carousel.getAttribute("data-cb-loop") === "true";
        const autoplay = carousel.getAttribute("data-cb-autoplay") ===
          "true" && {
          delay: parseInt(carousel.getAttribute("data-cb-autoplay-speed")),
          disableOnInteraction: false,
        };
        const breakpoints = JSON.parse(
          carousel.getAttribute("data-cb-breakpoints") || "{}",
        );

        // Create scrollbar element if it doesn't exist
        let scrollbar = carousel.querySelector(".swiper-scrollbar");
        if (!scrollbar) {
          scrollbar = document.createElement("div");
          scrollbar.className = "swiper-scrollbar";
          carousel.appendChild(scrollbar);
        }

        // Hide pagination bullets
        const pagination = carousel.querySelector(".cb-pagination");
        if (pagination) {
          pagination.style.display = "none";
        }

        // Mobile (<= 768px) slides have a fixed CSS width, so let Swiper measure
        // them ("auto") to keep the scrollbar progress in sync with the layout.
        // Breakpoint params are merged onto the base params, so every desktop
        // breakpoint must restore the desktop defaults.
        const desktopDefaults = { slidesPerView: 3.3, spaceBetween: spaceBetween };
        const breakpointKeys = Object.keys(breakpoints)
          .map(Number)
          .sort((a, b) => a - b);
        const desktopStartKey = breakpointKeys.filter((bp) => bp <= 769).pop();
        const carouselBreakpoints = {
          769: {
            ...desktopDefaults,
            ...(desktopStartKey !== undefined ? breakpoints[desktopStartKey] : {}),
          },
        };
        breakpointKeys
          .filter((bp) => bp > 769)
          .forEach((bp) => {
            carouselBreakpoints[bp] = { ...desktopDefaults, ...breakpoints[bp] };
          });

        // Reinitialize with the theme Swiper: the plugin's global Swiper is a
        // custom build without the Scrollbar module.
        new ThemeSwiper(swiperEl, {
          modules: [SwiperNavigation, SwiperAutoplay, SwiperScrollbar],
          slidesPerView: "auto",
          slidesPerGroup: slidesPerGroup,
          spaceBetween: 16,
          speed: speed,
          loop: loop,
          autoplay: autoplay,
          navigation: navigation && {
            nextEl: carousel.querySelector(".cb-button-next"),
            prevEl: carousel.querySelector(".cb-button-prev"),
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
            dragSize: "auto",
          },
          breakpoints: carouselBreakpoints,
          resizeObserver: false,
        });
      });
  }, 100);
});
document.addEventListener("DOMContentLoaded", () => {
  // Store preview URLs for later restoration
  const previewUrls = {};

  gform.addFilter(
    "gform_file_upload_markup",
    function (html, file, up, strings, imagesUrl, response) {
      var formId = up.settings.multipart_params.form_id;
      var fieldId = up.settings.multipart_params.field_id;

      // Get the secure preview URL from the server response
      var previewUrl =
        response && response.data && response.data.temp_preview_url;
      var uploadedFilename =
        response && response.data && response.data.uploaded_filename;

      // Store the preview URL by uploaded filename for later restoration
      if (uploadedFilename && previewUrl) {
        if (!previewUrls[formId]) previewUrls[formId] = {};
        if (!previewUrls[formId][fieldId]) previewUrls[formId][fieldId] = {};
        previewUrls[formId][fieldId][uploadedFilename] = previewUrl;
      }

      // Only show preview for image files
      if (previewUrl && file.type && file.type.match(/^image\//)) {
        html =
          '<img src="' +
          previewUrl +
          '" style="width:100%;height:auto;max-width:200px;"/>' +
          '<img class="gform_delete" ' +
          'src="' +
          imagesUrl +
          '/delete.png" ' +
          "onclick='gformDeleteUploadedFile(" +
          formId +
          "," +
          fieldId +
          ", this);' " +
          "alt='" +
          strings.delete_file +
          "' title='" +
          strings.delete_file +
          "' />";
      }

      return html;
    },
  );

  // Function to restore previews after form validation
  function restoreFilePreviews() {
    // Find all multi-file upload fields
    const multifileUploads = document.querySelectorAll(
      '[id^="gform_multifile_upload_"]',
    );

    multifileUploads.forEach((uploadElement) => {
      // Extract form and field ID from the element ID (e.g., gform_multifile_upload_21_7)
      const match = uploadElement.id.match(
        /gform_multifile_upload_(\d+)_(\d+)/,
      );
      if (!match) return;

      const formId = match[1];
      const fieldId = match[2];

      // Find the preview list
      const previewList = document.getElementById(
        `gform_preview_${formId}_${fieldId}`,
      );
      if (!previewList) return;

      // Find all delete buttons
      const deleteButtons = previewList.querySelectorAll(".gform_delete");

      deleteButtons.forEach((deleteBtn) => {
        // Get the filename from the <strong> tag
        const filenameElement = deleteBtn.parentElement.querySelector("strong");
        if (!filenameElement) return;

        const filename = filenameElement.textContent.trim();

        // Check if we have a stored preview URL for this file
        const previewUrl = previewUrls[formId]?.[fieldId]?.[filename];

        if (previewUrl) {
          // Only add image if it doesn't already exist
          const existingPreview = deleteBtn.previousElementSibling;
          if (!existingPreview || existingPreview.tagName !== "IMG") {
            const img = document.createElement("img");
            img.src = previewUrl;
            img.style.width = "100%";
            img.style.height = "auto";
            img.style.maxWidth = "200px";
            img.style.display = "block";
            img.style.marginBottom = "5px";
            deleteBtn.parentNode.insertBefore(img, deleteBtn);
          }
        }
      });
    });
  }

  // Restore previews on page load (in case of page refresh or back button)
  setTimeout(restoreFilePreviews, 100);

  // Hook into Gravity Forms validation to restore previews after validation errors
  jQuery(document).on("gform_post_render", function () {
    setTimeout(restoreFilePreviews, 100);
  });
});
